import { IAccountAllLang } from '../../../types/lang'
import { accountCrudModalLang } from './accountCrudModal'
import { accountPageLang } from './accountPage'
import { accountListTableLang } from './accountListTable'

export const accountAllLang: IAccountAllLang = {
	...accountPageLang,
	...accountCrudModalLang,
	...accountListTableLang
}